import { useDispatch, useSelector } from 'react-redux';
import { Radio } from 'antd';

import { Icon as CroplerIcon } from '@cropler/ui-kit';

import { selectPhotosType } from '../../store/slices/sensors';
import styles from './styles.module.scss';
import { useViewport } from '../../hooks';
import { BreakpointMobileUp } from '../../constants/ui';

const PhotosTypeSwitch = ({ isGrayView }) => {
  const dispatch = useDispatch();
  const { widthViewport } = useViewport();
  const { photosType } = useSelector((state) => state.sensors);

  const onChangeView = (e) => {
    const value = e.target.value;
    dispatch(selectPhotosType(value));
  };
  
  return (
    <div className={`${styles.buttonsList} ${isGrayView ? styles.buttonsListGray : ''}`}>
      <Radio.Group
        className={'radio-group radio-group--icons'}
        defaultValue={photosType === 'day' || photosType === 'ndvi' ? 'day' : 'night'}
        size={widthViewport < BreakpointMobileUp ? 'large' : null}
        onChange={onChangeView}
      >
        <Radio.Button value="day">
          <CroplerIcon name="day" width={widthViewport < BreakpointMobileUp ? 20 : 18} />
        </Radio.Button>
        <Radio.Button value="night">
          <CroplerIcon name="night" width={widthViewport < BreakpointMobileUp ? 18 : 16} />
        </Radio.Button>
      </Radio.Group>
    </div>
  );
};

export default PhotosTypeSwitch;
